import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { CyclistService } from 'src/app/services/cyclist.service';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-workshop-jobcard-delete-customer',
  templateUrl: './workshop-jobcard-delete-customer.component.html',
  styleUrls: ['./workshop-jobcard-delete-customer.component.scss']
})
export class WorkshopJobcardDeleteCustomerComponent {

  @Input() jobcard: any;
  @Input() customer: any;
  @Output() customerSelected = new EventEmitter<any>();

  public deleting: boolean = false;

    constructor(
      public activeModal: NgbActiveModal,
      private translate: TranslateService,
      private userService: UserService,
      private cyclistService : CyclistService,
      private helpersService: HelpersService
    ) { }

    ngOnInit() {
      console.log(this.jobcard);
    }


    deleteCustomer(){
      this.deleting = true;

      var data = {
        CustomerID: this.customer.ID,
        PartnerID: this.helpersService.getPartnerId(),
        CustomerName: this.customer.Name,
        CustomerSurname: this.customer.Surname,
        CustomerEmail: this.customer.Email,
        CustomerMobile: this.customer.PhoneNumber,
        POSCustomerID: this.customer.ExternalID || 0
      }

      this.userService.deleteCustomer(data).subscribe((response) => {
        this.deleting = false;
        this.jobcard.customer = null; // Clear the customer from the jobcard
        this.activeModal.close({ action: 'delete', customer: this.customer });
      }, (error) => {
        this.deleting = false;
        console.error('Error deleting customer:', error);
      });
    
    }

    cancel(){
      this.activeModal.dismiss('cancel');
    }

}
